
export default function generateContentProceduresCL(dataPDF) {

    return [
        // TITLE
        {
            stack: [
                {
                    text: dataPDF.title, style: 'header'
                },
            ]
        },
        {
            columns: [
                {
                    width: '50%',
                    stack: [
                        {
                            text: [{ text: 'DATOS DEL PACIENTE', fontSize: 12, bold: true }],
                            margin: [0, 0, 0, 10]
                        },
                        {
                            text: [{ text: 'Nombre: ', fontSize: 11, bold: true }, `${dataPDF.patientNameComplete} ${dataPDF.patientLastNameComplete}`],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'DNI: ', fontSize: 11, bold: true }, dataPDF.patientDNI],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Teléfono: ', fontSize: 11, bold: true }, dataPDF.patientPhoneComplete],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Dirección: ', fontSize: 11, bold: true }, dataPDF.patientAddress],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Ciudad: ', fontSize: 11, bold: true }, dataPDF.patientCity],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Fecha de Nacimiento: ', fontSize: 11, bold: true }, dataPDF.patientBirth],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Edad: ', fontSize: 11, bold: true }, dataPDF.patientAge],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Sexo: ', fontSize: 11, bold: true }, dataPDF.patientGender],
                            style: 'textP'
                        },
                    ],
                    margin: [0, 25, 0, 0],
                },
                {
                    width: '50%',
                    stack: [
                        {
                            text: [{ text: 'DATOS PROFESIONAL', fontSize: 12, bold: true }],
                            margin: [0, 0, 0, 10]
                        },
                        {
                            text: [{ text: 'Nombre: ', fontSize: 11, bold: true }, `${dataPDF.professionalNameComplete}`],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'DNI: ', fontSize: 11, bold: true }, dataPDF.professionalDNI],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Registro Médico: ', fontSize: 11, bold: true }, dataPDF.professionalMedicalId],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Especialidad: ', fontSize: 11, bold: true }, dataPDF.specialtyName],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Teléfono: ', fontSize: 11, bold: true }, dataPDF.professionalPhone],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Email: ', fontSize: 11, bold: true }, dataPDF.professionalEmail],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Dirección: ', fontSize: 11, bold: true }, dataPDF.professionalAddress],
                            style: 'textP'
                        },
                        {
                            text: [{ text: 'Ciudad: ', fontSize: 11, bold: true }, dataPDF.professionalCity],
                            style: 'textP'
                        },
                    ],
                    margin: [0, 25, 0, 0],
                },
            ]
        },

        {
            absolutePosition: { x: 430, y: 20 },
            stack: [
                {
                    text: [{ text: 'Fecha Emisión', fontSize: 10, bold: true }],
                },
                {
                    text: dataPDF.dateGenerate,
                    style: 'textP'
                },
                {
                    text: [{ text: `Hora: ${dataPDF.hourGenerate}`, fontSize: 10 }],
                },
            ],
            alignment: 'center'
        },

        // TREATMENT

        {
            stack: [
                {
                    text: 'PROCEDIMIENTOS',
                    style: 'subtitle'
                },
                {
                    text: dataPDF.textProcedures,
                    style: 'textP'
                }
            ],
            alignment: 'justify',
            margin: [0, 10, 0, 0],
        },

        // DATA SIGNATURE PROFESSIONAL, ADDRESS AND PHONE SALUTA
        {
            stack: [
                {
                    text: `${dataPDF.professionalNameComplete}\n`,
                    style: 'textF'
                },
                // {
                //     text: `${dataPDF.professionalDNI}\n`,
                //     style: 'textF'
                // },
                {
                    text: `Registro Médico: ${dataPDF.professionalMedicalId}\n`,
                    style: 'textF'
                },
                {
                    text: `${dataPDF.professionalEmail}\n`,
                    style: 'textF'
                },
            ]
        },

    ];
}